import { useState } from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';

import { useAuthStore } from '../../../store/authStore';
import SharedButton from '@/global/Button/Button';
import { useNavigate } from 'react-router-dom';

const registeredSsoProviders = { 'disgenet.com': 'entra-test', 'otsuka-us.com': 'otsuka' };

function Login() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const { logout } = useAuthStore();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    const emailValue = event.target.value.trim();
    setEmail(emailValue);
  };

  const handleCancel = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();
    navigate('/login', { replace: true });
  };

  const handleSso = async (evt: React.FormEvent) => {
    evt.preventDefault();
    try {
      setIsLoading(true);
      setErrorMessage('');

      if (!email) {
        throw new Error('Please enter your email address');
      }

      const domain = email.split('@')[1];
      if (Object.keys(registeredSsoProviders)?.includes(domain)) {
        const ssoProvider = registeredSsoProviders[domain];
        await signInWithRedirect({
          provider: { custom: ssoProvider },
        });
      } else {
        throw new Error(`Domain "${domain}" is not registered for SSO. Please contact support@disgenet.com`);
      }
    } catch (err) {
      const typedError = err as { message: string };
      setErrorMessage(typedError.message || 'An error occurred during SSO login');

      // cleanup session using AuthStore
      await logout();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="apply-trial-page">
      <link rel="canonical" href="/sso" />
      <div className="apply-trial-hero-bg" aria-hidden="true">
        <img src="/static/images/KeyVisuals/hero.png" alt="" className="hero-static-image" />
        <div className="hero-video-overlay" aria-hidden="true" />
      </div>
      <div className="apply-trial-content">
        <div className="home-hero-content">
          <div className="home-hero-section">
            <div className="container txt-contenido">
              {isLoading && (
                <div className="loading-overlay">
                  <div className="loading" />
                </div>
              )}
              <div className="login-container mb-5">
                <div className="form-apply w-full max-w-lg rounded-2xl">
                  <form onSubmit={handleSso}>
                    <h3 className="text-pink font-bold">SSO Login</h3>
                    <div className="text-left w-full mt-4" data-validate="Email is required">
                      <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">
                        Email:
                      </label>
                      <input
                        className="form-input"
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleChangeEmail}
                        required
                      />
                    </div>
                    <div className="text-right">
                      <a
                        className="text-gray-600 hover:text-blue-950 text-xs mr-2"
                        href="true"
                        onClick={handleCancel}
                      >
                        Cancel
                      </a>
                    </div>
                    <div className="container-contact100-form-btn mt-4">
                      <SharedButton type="submit" variant="primary" className="w-full">
                        Login
                      </SharedButton>
                    </div>
                    {errorMessage ? <p className="form-error">{errorMessage}</p> : null}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
